import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemDirective, ItemsDirective } from './items.directive';
import { ToolbarComponent } from './toolbar.component';
/**
 * NgModule definition for the Toolbar component.
 */
export class ToolbarModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        ToolbarComponent,
        ItemDirective,
        ItemsDirective
    ],
    exports: [
        ToolbarComponent,
        ItemDirective,
        ItemsDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ToolbarModule_tsickle_Closure_declarations() {
/** @type {?} */
ToolbarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ToolbarModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
